import { CreateUserHeader } from "./CreateUserHeader";
import CreateUserAnimation from "../../../../../../assets/jsons/create-user-animation.json";
import CreateUserAnimationDarkMode from "../../../../../../assets/jsons/create-user-animation-dark-mode.json";
import { LoaderText } from "./UserCreatedPreview/utils/constants";
import { UserCreationLoaderProps } from "./UserCreatedPreview/utils/types";
import { CircularAnimationLoader } from "../../../../../../components/Loader/CircularAnimationLoader";

export const UserCreationLoader = ({
  handleCloseDrawer,
}: UserCreationLoaderProps) => {
  return (
    <div className="p-[18px]">
      <CreateUserHeader handleCloseDrawer={handleCloseDrawer} />
      <div className="flex flex-col items-center justify-center gap-4 h-[calc(100vh-55px)]">
        <CircularAnimationLoader
          lightModeAnimation={CreateUserAnimation}
          darkModeAnimation={CreateUserAnimationDarkMode}
          loadingTexts={LoaderText}
        />
      </div>
    </div>
  );
};
